import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioRoutingModule } from './usuario-routing.module';
import { IndexComponent } from './pages/index/index.component';
import { NovoComponent } from './pages/novo/novo.component';
import { DetalhesComponent } from './pages/detalhes/detalhes.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {ReactiveFormsModule} from "@angular/forms";
import {EmpresaModule} from "../../cadastro/empresa/empresa.module";
import { ConfirmarEmailComponent } from './pages/confirmar-email/confirmar-email.component';
import { ConfiguracoesComponent } from './pages/configuracoes/configuracoes.component';
import {ComunicacaoModule} from "../../comunicacao/comunicacao.module";


@NgModule({
  declarations: [
    IndexComponent,
    NovoComponent,
    DetalhesComponent,
    ConfirmarEmailComponent,
    ConfiguracoesComponent
  ],
  imports: [
    CommonModule,
    UsuarioRoutingModule,
    ComponentesModule,
    NgSelectModule,
    ReactiveFormsModule,
    EmpresaModule,
    ComunicacaoModule
  ]
})
export class UsuarioModule { }
